"use client";

import { useStrictLocalization } from "@faire/localization/react/useStrictLocalization";
import React from "react";

import { TagDismissIcon } from "./TagDismissIcon";

type IProps = Omit<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  "className"
> & {
  tagLabel: string;
};

export const TagDismissButton: React.FC<IProps> = ({ tagLabel, ...props }) => {
  const { strictLocalize } = useStrictLocalization();
  return (
    <>
      <TagDismissIcon />
      <button
        {...props}
        aria-label={
          props["aria-label"] ??
          strictLocalize(
            {
              id: "0Ek4L3",
              defaultMessage: 'Remove tag "{tagFullyTranslatedSentence}"',
              description: {
                text: "The screenreader accessible message prompting user to remove the tag.",
                img: "https://cdn.faire.com/fastly/8cf27873199a1d3b9f5feff390bed574faa5c532dc4e3bded8a629bcc8c4ed75.png",
              },
            },
            {
              tagFullyTranslatedSentence: tagLabel,
            }
          )
        }
        className="fs-tag__dismiss-btn interactive focusable"
      />
    </>
  );
};
